export const NEWS_DETAILS_ENDPOINT = "/news/(.+)/";
export const ROAD_TEST_ENDPOINT = "/(.+)-cars/(.+)/expert-reviews/(.+)/";
export const COMPARISION_TEST_ENDPOINT = "/expert-reviews/(.+)/";
export const FEATURE_DETAILS_ENDPOINT = "/features/(.+)-([0-9]+)/";
export const LIVE_NEWS_DETAILS_ENDPOINT = "/news/live/(.+)/";
export const HINDI_NEWS_DETAILS_ENDPOINT = "/hi/news/(.+)/";
export const PIT_STOP_DETAILS_ENDPOINT = "/pitstop/(.+)-([0-9]+)/";
export const HINDI_ROAD_TEST_ENDPOINT =
  "/hi/(.+)-cars/(.+)/expert-reviews/(.+)/";
export const HINDI_COMPARISION_TEST_ENDPOINT = "/hi/expert-reviews/(.+)/";
export const HINDI_FEATURE_DETAILS_ENDPOINT = "/hi/features/(.+)-([0-9]+)/";
export const AUTOEXPO_NEWS_ENDPOINT = "/autoexpo/2020/news/";

export const PAGE_TYPE = {
  NEWS_DETAILS: "NEWS_DETAILS",
  EXPERT_REVIEWS: "EXPERT_REVIEWS",
  FEATURE_DETAILS: "FEATURE_DETAILS",
  PIT_STOP_DETAILS: "PIT_STOP_DETAILS",
  LIVE_NEWS_DETAILS: "LIVE_NEWS_DETAILS",
  HINDI_NEWS: "HINDI_NEWS",
  HINDI_EXPERT_REVIEWS: "HINDI_EXPERT_REVIEWS",
  HINDI_FEATURE_DETAILS: "HINDI_FEATURE_DETAILS",
  AUTOEXPO_NEWS: "AUTOEXPO_NEWS",
  IMAGE_DETAILS: "IMAGES",
  COLOUR_DETAILS: "COLORS",
  VIDEO_DETAILS: "VIDEOS",
};

export const CATEGORIES = {
  NEWS: 1,
  COMPARISON_TESTS: 2,
  FEATURES: 6,
  ROAD_TESTS: 8,
  IMAGES: 10,
  HINDI_NEWS: 31,
  PIT_STOP: 12,
  VIDEOS: 13,
  SPECIAL_FEATURES: 18,
  AUTO_EXPO_2016: 19,
  ADVERTORIAL: 22,
  HINDI_ROAD_TESTS: 32,
  HINDI_FEATURES: 33,
  HINDI_SPECIAL_FEATURES: 35,
  HINDI_COMPARISON_TESTS: 36,
  AUTOEXPO_NEWS: 1.8,
};
